import {ReactNode, useState} from "react";
import {
  CrossSectionFields,
  CrossSectionFieldsIface,
  SetCrossSectionFields,
} from "@/hooks/use-cross-section-fields";

export function CrossSectionFieldsProvider({
                                             children,
                                           }: {
  children: ReactNode;
}) {
  const [cc, setCc] = useState<CrossSectionFieldsIface>({});
  return (
    <CrossSectionFields.Provider value={cc}>
      <SetCrossSectionFields.Provider value={setCc}>
        {children}
      </SetCrossSectionFields.Provider>
    </CrossSectionFields.Provider>
  );
}
